export function Footer() {
  return (
    <footer>
      <div className="footer-content">
        <span className="span">Copyright © 2026 广州市桃高网络科技有限公司</span>
        <div className="link">
          <a href="https://beian.mps.gov.cn/#/query/webSearch" rel="noreferrer" target="_blank">
            <span className="icon">
              <img src="/image/1.jpg" />
            </span>
            <span>粤公网安备44011102484763号</span>
          </a>
          <a href="https://beian.miit.gov.cn/" target="_blank">
            <span>粤ICP备2026040742号-1</span>
          </a>
        </div>
      </div>
    </footer>
  );
}
